import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages'
import store from '@/store'
import iView from 'view-design'
// import HomePage from '@/pages/HomePage'
// import Enter from '@/pages/Enter'
import PersonIndex from '@/pages/PersonIndex'
import Error403 from '@/pages/Error403'
import Error404 from '@/pages/Error404'
import axios from 'axios'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => console.log(err))
}
const files = require.context('../router', true, /index\.js$/i)
let childrenRouter = []
files
  .keys()
  .map(files)
  .filter((v) => Array.isArray(v.default))
  .forEach((v) => (childrenRouter = childrenRouter.concat(v.default)))
function isPc() {
  let reg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  if (window.navigator.userAgent.match(reg)) {
    return false // 移动端
  } else {
    return true // PC端
  }
}
const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      props: (route) => ({ redirect: route.query.redirect || '' }),
      component: () => import('@/pages/Login'),
      meta: { ignoreLogin: true },
    },
    {
      path: '/',
      redirect: '/personIndex',
      name: 'Index',
      component: Index,
      children: [
        {
          path: 'personIndex',
          name: 'PersonIndex',
          component: PersonIndex,
        },
        {
          path: 'applicationManagement',
          name: 'ApplicationManagement',
          component: () => import('@/pages/ApplicationManagement'),
        },
        {
          path: 'applicationManagementList',
          name: 'ApplicationManagementList',
          component: () => import('@/pages/ApplicationManagement/list'),
          meta: { name: '库存配置' },
        },
        {
          path: 'trigger',
          name: 'Trigger',
          component: () => import('@/pages/trigger'),
          meta: { name: '时间段设置' },
        },
        {
          path: 'globalVariable',
          name: 'GlobalVariable',
          component: () => import('@/pages/globalVariable'),
          meta: { name: '自动接单设置' },
        },
        {
          path: 'singleSet',
          name: 'SingleSet',
          component: () => import('@/pages/singleSet'),
          meta: { name: '派单台数' },
        },
        {
          path: 'appointment',
          name: 'Appointment',
          component: () => import('@/pages/appointment'),
          meta: { name: '预约单' },
        },
        {
          path: 'MeiTuanSystemSetting',
          name: 'MeiTuanSystemSetting',
          props: () => ({ sType: 'dianping' }),
          component: () => import('@/views/DouYinSystemSetting'),
          meta: { name: '系统设置' },
        },
        {
          path: 'DouYinSystemSetting',
          name: 'DouYinSystemSetting',
          props: () => ({ sType: 'douyin' }),
          component: () => import('@/views/DouYinSystemSetting'),
          meta: { name: '系统设置' },
        },

        {
          path: 'DouYinProduct',
          name: 'DouYinProduct',
          component: () => import('@/views/DouYinProduct'),
          meta: { name: '商品管理' },
        },
        {
          path: 'ProductAdd/:productId?',
          name: 'ProductAdd',
          props: true,
          component: () => import('@/views/DouYinProduct/ProductAdd'),
          meta: { name: '添加商品' },
        },
        {
          path: 'DouYinStore',
          name: 'DouYinStore',
          component: () => import('@/views/DouYinStore'),
          meta: { name: '门店列表' },
        },
        {
          path: 'MeituanStore',
          name: 'MeituanStore',
          component: () => import('@/views/MeituanStore'),
          meta: { name: '门店列表' },
        },
        {
          path: 'DouYinOrderList',
          name: 'DouYinOrderList',
          component: () => import('@/views/DouYinOrderList'),
          meta: { name: '订单列表' },
        },
        {
          path: 'orderList/detail/:orderId',
          name: 'DouYinOrderDetail',
          props: true,
          component: () =>
            import('@/views/DouYinOrderList/DouyinOrderDetail.vue'),
          meta: { name: '订单详情' },
        },
        {
          path: 'DouYinSKU',
          name: 'DouYinSKU',
          component: () => import('@/views/DouYinSKU'),
          meta: { name: 'SKU管理' },
        },
        {
          path: 'DouYinAuth',
          name: 'DouYinAuth',
          component: () => import('@/views/DouYinAuth'),
          meta: { name: 'DouYin账户授权' },
        },
        {
          path: 'MeituanAuth',
          name: 'MeituanAuth',
          component: () => import('@/views/MeituanAuth'),
          meta: { name: '美团账号授权' },
        },
        // ...childrenRouter,
        {
          path: '/Error404',
          name: 'Error404',
          component: Error404,
          meta: { name: '错误' },
        },
      ],
    },
    {
      path: '/dataMap',
      name: 'DataMap',
      component: () =>
        isPc()
          ? import('@/pages/dataMap/index.vue')
          : import('@/pages/dataMap/indexMob.vue'),
      meta: { name: '服务大数据' },
    },
    {
      path: '/questionnaire/:surveyId/:nodeTmplId',
      name: 'questionnaire',
      component: () =>
        isPc()
          ? import('@/pages/questionnaire/questionnaire/index.vue')
          : import('@/pages/questionnaire/questionnaire/indexMob.vue'),
      meta: { name: '问卷信息', keepAlive: false, ignoreLogin: true },
    },
    {
      path: '/error403',
      name: 'Error403',
      component: Error403,
      meta: { name: '错误' },
    },
  ],
})

router.beforeEach((to, from, next) => {
  // 未匹配到路由则跳转至404
  if (to.matched.length === 0) {
    next({ name: 'Error404' })
    return
  }
  // 未登录 且meta无ignoreLogin属性 则跳转至登录
  if (!to.matched[to.matched.length - 1].meta.ignoreLogin) {
    if (Object.keys(store.state.user.user).length === 0) {
      axios.get('/user/info').then((res) => {
        if (res.success) {
          store.commit('user/_user', res.data)
          return next({ name: 'PersonIndex' })
        }
      })
      return next({ name: 'Login', query: { redirect: to.name || '' } })
    }
  }
  iView.LoadingBar.start()
  next()
  // 点击菜单 初始化vuex中的routerLinkUrl
  if (typeof to.meta.name === 'string') {
    store.commit('menu/_routerLinkUrl', [])
  }
  let routerLinkUrl = store.state.menu.routerLinkUrl || []
  if (routerLinkUrl.length === 0) {
    routerLinkUrl.push({ path: to.fullPath, name: to.meta.name })
    store.commit('menu/_routerLinkUrl', routerLinkUrl)
  } else {
    // 路由来源和routerLinkUrl中最后一个路径相同时 push当前路径
    if (
      routerLinkUrl[routerLinkUrl.length - 1].path === from.fullPath &&
      to.meta.name &&
      to.meta.name[routerLinkUrl.length]
    ) {
      routerLinkUrl.push({
        path: to.fullPath,
        name: to.meta.name[routerLinkUrl.length],
      })
      store.commit('menu/_routerLinkUrl', routerLinkUrl)
    } else {
      // 点击面包屑时 移除后置位的面包屑
      let centerRouter = routerLinkUrl.slice(1, routerLinkUrl.length - 1)
      centerRouter.forEach((val, index) => {
        if (val.path === to.fullPath) {
          routerLinkUrl.splice(index + 2, routerLinkUrl.length - index + 1)
          store.commit('menu/_routerLinkUrl', routerLinkUrl)
        }
      })
    }
  }
  store.commit('menu/_breadcrumbList', routerLinkUrl)

  let rootPath = to.fullPath.split('/')[1]
  rootPath = rootPath[0].toUpperCase() + rootPath.substring(1)
  if (rootPath === 'GuideOne') {
    store.commit('menu/_tag', '-1')
  } else {
    let thirdMenuList = store.state.menu.thirdMenuList
    if (store.state.menu.menuIsLoadingOver) {
      for (let key in thirdMenuList) {
        thirdMenuList[key].forEach((val) => {
          if (val.routerName === rootPath) {
            store.commit('menu/_tag', val.parent_id + '-' + val.id)
          }
        })
      }
    }
  }
})

router.afterEach((to, from) => {
  // 关闭加载进度条
  if (to.matched[to.matched.length - 1].name === 'Error') {
    iView.LoadingBar.error()
  }
  iView.LoadingBar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js